window.addEventListener('load',()=>{
  /* Menu - Open/Close */
  /* -------------------------------------------------------------------------------------- */
  $('.js-open-data').on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    var el = $(this),
      item = $(el.attr('data-open'));
    el.addClass('active');
    item.addClass('active');
    item.attr('open', 'true');
  });

  $('.js-close-data').on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    var el = $(this),
      item = $(el.attr('data-close'));
    el.removeClass('active');
    item.removeClass('active');
    item.removeAttr('open');
  });
});